import { FC, forwardRef } from "react";
import CreateProjectStructureFolderSvg from "../../public/icons/Create_Project_Structure_Folder.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const CreateProjectStructureFolders: FC<IconProps> = forwardRef(
  function CreateProjectStructureFolders(iconProps, ref) {
    return <span role="img" ref={ref} {...useAddMissingAntIconClass(iconProps)}><CreateProjectStructureFolderSvg/></span>;
  },
);
